export default "__VITE_ASSET__q4J9_Of1__"